import { useCallback, useEffect, useState } from 'react';
import { STAGE_STATUS } from '../../../constants/constants';

const useSetPostData = (data, sendJsonMessage) => {
  const [postPerformance, setPostPerformance] = useState(false);
  const [openAngleModal, setOpenWallClimbPost] = useState(false);
  const [postData, setPostData] = useState();

  const handleeSetPostData = useCallback(() => {
    if (data?.response_data.stage === STAGE_STATUS.POST_PERFORMANCE) {
      setPostPerformance(true);
      setPostData(data.response_data.post_data);
      if (data?.response_data?.post_data?.angle > 0) {
        setOpenWallClimbPost(true);
      } else {
        setPostPerformance(true);
      }
    }
  }, [data, sendJsonMessage]);

  const handleeOneSetPostData = useCallback(() => {
    if (data?.response_data?.stage === STAGE_STATUS.SET_STAGE) {
      setPostData(data?.response_data?.post_data);
      setPostPerformance(false);
    }
  }, [data]);

  useEffect(() => {
    handleeSetPostData();
    handleeOneSetPostData();
  }, [data?.response_data.stage, data?.response_data.post_data]);

  return { postPerformance, postData, openAngleModal };
};

export default useSetPostData;
